import { useContext } from 'react'
import FileViewerContext from './fileViewerContext'
import { FileViewerData } from './FileViewerContainer'

/**
 * A hook that allows a file to be shown in the file viewer from anywhere in the app.
 * @returns
 */
export function useFileViewer(): {
  setIsFileVisible: (value: boolean) => void
  setData: (data: FileViewerData) => void
} {
  const { fileViewerRef } = useContext(FileViewerContext)

  return {
    setIsFileVisible: fileViewerRef.current
      ? fileViewerRef.current.setIsFileVisible
      : () => undefined,
    setData: fileViewerRef.current
      ? fileViewerRef.current?.setData
      : () => undefined,
  }
}
